import {
  MarketingTriggerKey,
  OrderTrackingTriggerKey,
} from "@redotech/redo-model/advanced-flow/triggers";
import { ShopperAgentCooldownConfigSchema } from "@redotech/redo-model/shopper-agent/cooldown-config";
import { ShopperAgentDiscountConfigSchema } from "@redotech/redo-model/shopper-agent/discount-config";
import { ShopperAgentIMessageConfigSchema } from "@redotech/redo-model/shopper-agent/imessage-config";
import { SkillConfigSchema } from "@redotech/redo-model/shopper-agent/skill-config";
import * as z from "zod/v4";

/**
 * Input schema for updating a trigger.
 *
 * - Pass `config: null` to remove the entire trigger override.
 * - Within config, pass a field as `null` to remove that specific override
 *   (e.g. `discountConfig: null` removes the discount override so it inherits
 *   from base). Pass `undefined`/omit to leave unchanged.
 */
const TriggerUpdateConfigSchema = z.object({
  enabled: z.boolean().optional(),
  iMessageConfig: ShopperAgentIMessageConfigSchema.nullable().optional(),
  discountConfig: ShopperAgentDiscountConfigSchema.nullable().optional(),
  cooldownConfig: ShopperAgentCooldownConfigSchema.nullable().optional(),
  skills: z.record(z.string(), SkillConfigSchema).nullable().optional(),
  guidance: z.string().nullable().optional(),
});

export const updateShopperAgentTrigger = {
  name: "updateShopperAgentTrigger" as const,
  input: z.object({
    triggerId: z.enum([
      ...Object.values(MarketingTriggerKey),
      ...Object.values(OrderTrackingTriggerKey),
    ]),
    config: TriggerUpdateConfigSchema.nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
